import produce from "immer";
import { replaceIfChanged } from '../StoreUtils/overrideState';

const initialState = {
    priceAlerts: {},
    getAllCommand: {
        cmdId: 'STD.CMD.Server',
        storeRef: {},
        staticParams: {
            postUrl: 'api/priceAlert/getAccountPriceAlertList',
        }
    },
    markForFutureFetch: true, // Start with true to trigger initial fetch
    isActive: false,
    continuationToken: null, // Store the continuation token from the server
    knownSeq: null // Store the known sequence number if provided
};

export const priceAlertsReducer = function priceAlertsReducer(state = initialState, action) {
    switch (action.type) {
        
        case 'price-alerts-page-activity':
            {
                return produce(state, draft => {
                    draft.isActive = action.payload.isActive;
                    // No need to modify other flags here - the component will handle fetching based on markForFutureFetch
                });
            }
        case "price-alerts-arrived":
            {
                return produce(state, draft => {
                    handlePriceAlerts(draft, action.payload);
                    draft.markForFutureFetch = false;
                    
                    // Store the continuation token if provided in the response
                    if (action.payload.ContinuationToken !== undefined) {
                        draft.continuationToken = action.payload.ContinuationToken;
                    }
                    
                    // Update knownSeq if provided
                    if (action.payload.KnownSeq !== undefined) {
                        draft.knownSeq = action.payload.KnownSeq;
                    }
                });
            }
            
        case "login-logout":
            {
                return produce(state, draft => {
                    handlePriceAlerts(draft, {PriceAlerts:[]});
                    draft.markForFutureFetch = true;
                    draft.continuationToken = null;
                    draft.knownSeq = null;
                });
            }
            

        
        case "SET_MARK_FOR_FUTURE_FETCH":
            {
                return produce(state, draft => {
                    draft.markForFutureFetch = action.payload;
                });
            }
            
        case "UPDATE_PRICE_ALERTS_SEQ":
            {
                return produce(state, draft => {
                    draft.knownSeq = action.payload;
                });
            }
            
        default:
            return state;
    }
}

const statusOptions = [
    { DisplayName: "Active", Value: 0 },
    { DisplayName: "Canceled", Value: 1 },
    { DisplayName: "Triggered", Value: 2 },
  ];

const sideOptions = [
    { DisplayName: "Buy", Value: 0 },
    { DisplayName: "Sell", Value: 1 },
];

const conditionOptions = [
    { DisplayName: "Greater Than", Value: 0 },
    { DisplayName: "Less Than", Value: 1 },
  ];

function handlePriceAlerts(draft, serverPriceAlerts) {
    let stateAlerts = draft.priceAlerts;
    let serverAlerts = serverPriceAlerts.PriceAlerts || [];
    
    // Create a set of server alert IDs for quick lookup
    const serverAlertIds = new Set();
    for (let serverAlertKey in serverAlerts) {
        const serverAlert = serverAlerts[serverAlertKey];
        if (serverAlert.Id) {
            serverAlertIds.add(serverAlert.Id);
        }
    }
    
    // Remove alerts that exist in state but not in the server data
    for (let stateAlertId in stateAlerts) {
        if (!serverAlertIds.has(stateAlertId)) {
            delete stateAlerts[stateAlertId];
        }
    }
    
    // Update or add alerts from server data
    for (let serverAlertKey in serverAlerts) {
        let serverAlert = serverAlerts[serverAlertKey];
        let stateAlert = stateAlerts[serverAlert.Id];
        if (!stateAlert) {
          stateAlert = { id: serverAlert.Id };
          stateAlerts[serverAlert.Id] = stateAlert;
        }
        stateAlert.symbol = serverAlert.Symbol;
        stateAlert.walletId = serverAlert.WalletId;
        stateAlert.status = statusOptions.find(o => o.Value === serverAlert.Status)?.DisplayName;
        stateAlert.price = serverAlert.Price;
        stateAlert.side = sideOptions.find(o => o.Value === serverAlert.Side)?.DisplayName;
        stateAlert.condition = conditionOptions.find(o => o.Value === serverAlert.Condition)?.DisplayName;
        stateAlert.created = serverAlert.Created;
        stateAlert.updated = serverAlert.Updated;
        stateAlert.comment = serverAlert.Comment;
        stateAlert.externalId = serverAlert.ExternalId;
        stateAlert.accountId = serverAlert.AccountId;
    }

    return draft;
}

export const setPriceAlerts = (priceAlerts) => ({
    type: 'price-alerts-arrived',
    payload: { priceAlerts }
});

export const setMarkForFutureFetch = (mark) => ({
    type: 'SET_MARK_FOR_FUTURE_FETCH',
    payload: mark
});

export const updatePriceAlertsSeq = (seq) => ({
    type: 'UPDATE_PRICE_ALERTS_SEQ',
    payload: seq
});

export const deletePriceAlert = (alertId) => ({
    type: 'DELETE_PRICE_ALERT',
    payload: alertId
});


